export default __webpack_public_path__ + "static/media/trezor.c0ea4627.svg";